import { Icon } from "@trussworks/react-uswds";

// styles
import styles from "./Footer.module.scss";
import DebugFooter from "./DebugFooter";

const SBAHLogoImage = require("../../../assets/images/sba_logo_horizontal.png");

const footerLinks = [
  {
    url: "https://www.sba.gov/contracting",
    label: "SBA.gov/contracting",
    ariaLabel: "Learn more about contracting on SBA.gov",
  },
  {
    url: "https://whitehouse.gov",
    label: "WhiteHouse.gov",
    ariaLabel: "Visit the official White House website",
  },
  {
    url: "https://regulations.gov",
    label: "Regulations.gov",
    ariaLabel: "Find regulations and rules on Regulations.gov",
  },
  {
    url: "https://business.usa.gov",
    label: "BusinessUSA.gov",
    ariaLabel: "Discover business resources at BusinessUSA.gov",
  },
  {
    url: "https://usa.gov",
    label: "USA.gov",
    ariaLabel: "Visit the USA.gov official government website",
  },
  {
    url: "/accessibility",
    label: "Accessibility",
    ariaLabel: "Learn more about accessibility on SBA.gov",
  },
];

const socialLinks = [
  {
    href: "https://www.facebook.com/SBAgov",
    name: <Icon.Facebook aria-hidden="true" />,
    label: "Visit our Facebook page",
  },
  {
    href: "https://www.twitter.com/SBAgov",
    name: <Icon.Twitter aria-hidden="true" />,
    label: "Visit our Twitter page",
  },
  {
    href: "https://youtube.com/c/sbagov",
    name: <Icon.Youtube aria-hidden="true" />,
    label: "Visit our YouTube channel",
  },
  {
    href: "https://instagram.com/sbagov",
    name: <Icon.Instagram aria-hidden="true" />,
    label: "Visit our Instagram page",
  },
  {
    href: "https://rss.feedburner.com/sbagov",
    name: <Icon.RssFeed aria-hidden="true" />,
    label: "Subscribe to our RSS feed",
  },
];

export default function Footer() {
  const scrollToTop = () => {
    scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className={styles["footer-root"]}>
      <div className={styles["to-top-wrapper"]}>
        <div className={styles["to-top"]}>
          <button role="button" onClick={scrollToTop}>
            Return to top
          </button>
        </div>
      </div>
      <div className={styles["links-section-wrapper"]}>
        <div className={styles["links-section"]}>
          {footerLinks.map((item, i) => (
            <a
              key={i}
              href={item.url}
              rel="noreferrer"
              target="_blank"
              className={styles["link"]}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
      <div className={styles["content-section-wrapper"]}>
        <div className={styles["content-section"]}>
          <a
            href="https://www.sba.gov"
            rel="noreferrer"
            target="_blank"
            className={styles["img-wrapper"]}
          >
            <img src={SBAHLogoImage} alt="SBA Logo" />
          </a>

          <div className={styles["social-content"]}>
            <div className={styles["social-links"]}>
              {socialLinks.map((item, i) => (
                <a
                  key={i}
                  href={item.href}
                  rel="noreferrer"
                  target="_blank"
                  aria-label={item.label}
                >
                  {item.name}
                </a>
              ))}
            </div>

            {/* <h3>Contact SBA</h3>
          <a href="#">SBS Help Desk</a> */}
          </div>
        </div>
      </div>
      <DebugFooter />
    </footer>
  );
}
